import { styled, createGlobalStyle } from "styled-components";

/* Fonts (Geist, Geist Mono, Newsreader) are loaded in public/index.html. */

export const tokens = {
  cream: "#f8f2e9",
  cream2: "#f1e9db",
  ink: "#2b2b2b",
  body: "#3a3630",
  soft: "#6b655c",
  rule: "#e6dfd6",
  blue: "#3a75c4",
  blueLine: "rgba(58, 117, 196, 0.45)",
  sans: `'Geist', 'Helvetica Neue', Arial, sans-serif`,
  serif: `'Newsreader', Georgia, serif`,
  mono: `'Geist Mono', ui-monospace, Menlo, monospace`,
  column: 520,
};

export const GlobalStyle = createGlobalStyle`
  html {
    scroll-behavior: smooth;
    scroll-padding-top: 96px;
  }
  @media (prefers-reduced-motion: reduce) {
    html { scroll-behavior: auto; }
  }
  body {
    margin: 0;
    background: ${tokens.cream};
    color: ${tokens.body};
    font-family: ${tokens.sans};
    font-size: 14.5px;
    line-height: 1.65;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  a {
    color: ${tokens.ink};
    text-decoration: underline;
    text-decoration-color: ${tokens.blueLine};
    text-decoration-thickness: 1px;
    text-underline-offset: 3px;
    transition: color 0.2s, text-decoration-color 0.2s;
  }
  a:hover { color: ${tokens.blue}; text-decoration-color: ${tokens.blue}; }
  a:focus-visible, button:focus-visible {
    outline: 2px solid ${tokens.blue};
    outline-offset: 3px;
    border-radius: 2px;
  }
  p { margin: 0; }
`;

/* The narrow reading column every page sits in. */
export const Container = styled.div`
  max-width: ${tokens.column}px;
  margin: 0 auto;
  padding: 0 24px 120px;
`;

/* Space between the nav and the first thing on a page. */
export const Page = styled.main`
  padding-top: 64px;
`;

export const SerifTitle = styled.span`
  font-family: ${tokens.serif};
  font-weight: 500;
  letter-spacing: -0.005em;
  color: ${tokens.ink};
`;

export const Meta = styled.div`
  font-size: 13px;
  color: ${tokens.soft};
  font-variant-numeric: tabular-nums;
`;

/* A link-styled button, used for "bibtex" and "copy". */
export const TextButton = styled.button`
  font: inherit;
  color: ${(p) => (p.$active ? tokens.blue : tokens.ink)};
  background: none;
  border: 0;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
  text-decoration-color: ${(p) => (p.$active ? tokens.blue : tokens.blueLine)};
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;
  transition: color 0.2s, text-decoration-color 0.2s;
  &:hover { color: ${tokens.blue}; text-decoration-color: ${tokens.blue}; }
`;